export function loadModules(context) {
  const modules = context
    .keys()
    .map(key => {
      return {
        key,
        name: key
          .replace(/(\.\/|(index)?\.(store\.)?js)/gi, '')
          .split('/stores/')
          .filter(x => !!x)
          .join('/'),
      };
    })
    .reduce(
      (modules, { key, name }) => ({
        ...modules,
        [name]: context(key).default || context(key),
      }),
      {}
    );

  return modules;
}

export function registerDynamicModules(store, modules, reload = false) {
  const registerNamespaced = key => {
    if (!key || key.length === 0 || store.hasModule(key)) return;
    const value = modules[key.join('/')] || {};
    value.namespaced = true;
    store.registerModule(key, value);
  };

  // https://v3.vuex.vuejs.org/guide/modules.html#dynamic-module-registration
  for (let storeName in modules) {
    const storePathArray = storeName.split('/');

    if (reload) {
      store.unregisterModule(storePathArray);
    }

    // nested store module registration
    storePathArray.reduce((traversed, current) => {
      traversed.push(current);
      registerNamespaced(traversed);
      return traversed;
    }, []);
  }

  return store;
}
